import { useEffect, useRef } from "react";
import { TileLayer, Marker, Popup, LayersControl, LayerGroup, useMap } from "react-leaflet";
import L, { Control, LatLngExpression } from "leaflet";
import "leaflet-easybutton";
import { Link, useParams } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import youAreHere from "src/img/maps/youAreHere.png";
import truck from "src/img/maps/truck.png";
import truckrun from "src/img/maps/truckrun.png";
import logo from "src/img/logo.png";
import UserInfo from "src/components/common/userInfo";
import { useAuthStore } from "src/components/main/authStore";
import {
    projectCategoryColorCode
} from "src/components/common/functions";
import MapSize from "./mapSize";
import CustomMarker from "./customMarker";
import type { MapTruck, MapWorkRow } from "./types";
//--------------------------------------------------------------------------------------------
type MapLayersProps = {
    geoData: MapTruck[];
    mapFull: boolean;
    works: MapWorkRow[];
};

type WatermarkControlConstructor = new (options?: L.ControlOptions) => Control;

type LeafletWithWatermark = typeof L & {
    Control: typeof Control & {
        Watermark?: WatermarkControlConstructor;
    };
    control: typeof L.control & {
        watermark?: (opts: L.ControlOptions) => Control;
    };
};

export default function Maps({
    geoData, 
    mapFull, 
    works, 
}: MapLayersProps){
    const { id: itemId } = useParams();
    //--------------------------------------------------------------------------------------------
    const user = useAuthStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const map = useMap();
    //--------------------------------------------------------------------------------------------
    const truckicon = L.icon({
        iconUrl: truck,
        iconSize: [45, 45]
    });
    const truckrunicon = L.icon({
        iconUrl: truckrun,
        iconSize: [45, 45]
    });
    const youAreHereIcon = L.icon({
        iconUrl: youAreHere,
        iconSize: [45, 45]
    });
    const projects = Object.entries(projectCategoryColorCode).map(([key, value]) => ({
        name: value.title, 
        category: key, 
        icon: value.icon
    }));
    const thisWatermark = useRef<Control | null>(null);
    const easyButton1 = useRef<unknown>(null);
    useEffect(() => {
        if(map){
            const scale = L.control.scale();
            map.addControl(scale);
        }
    }, [map])
    useEffect(() => {
        if(!thisWatermark.current && map){
            const leaflet = L as LeafletWithWatermark;
            leaflet.control.watermark = opts => {
                return new leaflet.Control.Watermark!(opts);
            }
            const WatermarkControl = Control.extend({
                onAdd: () => {
                    const img = L.DomUtil.create("img") as HTMLImageElement;
                    img.src = logo;
                    return img;
                }
            }) as unknown as WatermarkControlConstructor;
            leaflet.Control.Watermark = WatermarkControl;
            thisWatermark.current = leaflet.control
            .watermark!({ position: "bottomright" })
            .addTo(map);
        }
        if(!easyButton1.current && map){
            easyButton1.current = L.easyButton(`<span>✎</span>`, (btn, map) => {
                window.alert("pen");
                //const currfile = winow.prompt("New drawing name: ");
                // if(currfile === null) return;
                // if(currfile === ""){
                //     window.alert("Name is required to void.");
                //     return;
                // }
                //const editableLayers = new L.FeatureGroup();
                //L.layerControl.addOverlay(editableLayers, currfile);
                //map.addLayer(editableLayers);
            },"pen").addTo(map);
            L.easyButton(`<span>★</span>`, (btn, map) => {
                window.alert("star");
            },"star").addTo(map);
        }
    }, [map]);
    useEffect(() => {
        // Wait for the DOM to update
        const checkboxes = document.querySelectorAll(".leaflet-control-layers-selector");
        checkboxes.forEach((checkbox, index) => {
          checkbox.id = `layer-checkbox-${index}`; // Assigns unique ID
        });
      }, []);
    //--------------------------------------------------------------------------------------------
    return(
        <>
            <MapSize mapFull = {mapFull}/>
            <LayersControl position = "topright">
                <LayersControl.BaseLayer checked name = "Google Maps">
                    <TileLayer
                        attribution = ""
                        url = "https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name = "Google Satellite">
                    <TileLayer
                        attribution = ""
                        url = "http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name = "Google Satellite Hybrid">
                    <TileLayer
                        attribution = ""
                        url = "https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name = "Google Terrain">
                    <TileLayer
                        attribution = ""
                        url = "https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name = "Google Roads">
                    <TileLayer
                        attribution = ""
                        url = "https://mt1.google.com/vt/lyrs=h&x={x}&y={y}&z={z}"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name = "Open Street Map">
                    <TileLayer
                        attribution = ""
                        url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                </LayersControl.BaseLayer>
                {false?
                <LayersControl.BaseLayer name = "Black And White">
                    <TileLayer
                        attribution = ""
                        url = "https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png"
                    />
                </LayersControl.BaseLayer>
                :<></>}
                <LayersControl.Overlay name = "You are here" checked>
                    <Marker position = {user?.coords ?? [37.6148754, -122.0874473]} icon = {youAreHereIcon}>
                        <Popup>
                            your current location
                        </Popup>
                    </Marker>
                </LayersControl.Overlay>
                <LayersControl.Overlay name = "Trucks" checked = {true || geoData.map((e: MapTruck) => e.name).includes(itemId ?? "")}>
                    <LayerGroup>
                        {geoData.map((e: MapTruck, i: number) => 
                        <CustomMarker key = {i}
                            position = {[
                                e.eventData?.latitude ?? 0, 
                                e.eventData?.longitude ?? 0
                            ] as LatLngExpression}
                            icon = {e.eventData?.isDriving?truckicon:truckrunicon}
                            isActive = {itemId === e.name}
                            hash = {e.name}
                            map = {map}
                        >
                            <br/>
                            <div className = "leaflet-popup-title">ID: {e.id}</div>
                            <div className = "py-1">
                                <span className = "fw-bold me-1">Name:</span>
                                <Link to = {`/Fleets/${e.name}`}>{e.name}</Link>
                            </div>
                        </CustomMarker>
                        )}
                    </LayerGroup>
                </LayersControl.Overlay>
                {projects.map((v, k) => 
                <LayersControl.Overlay checked key = {k} name = {v.name}>
                    <LayerGroup>
                        {works
                        .map((w: MapWorkRow, i: number) => w.coords && w.category === v.category?
                        <CustomMarker
                            key = {i} 
                            position = {[
                                parseFloat(w.coords?.split(",")[0] ?? 0), 
                                parseFloat(w.coords?.split(",")[1] ?? 0)
                            ] as LatLngExpression} 
                            icon = {
                                L.icon({
                                    iconUrl: v.icon,
                                    iconSize: [45, 45]
                                })
                            }
                            isActive = {itemId === w.workId}
                            hash = {w.workId}
                            map = {map}
                             
                        >
                            <div className = "leaflet-popup-title">{v.category}</div>
                            <div className = "pt-2 lineHeight15">
                                <span className = "fw-bold me-1">Project Name:</span>
                                <Link className = "forLink" to = {
                                    `/Works/${w.workId}`
                                }>
                                    {w.projectName}
                                </Link>
                            </div>
                            <div className = "pt-2 lineHeight15">
                                <span className = "fw-bold me-1">Project Manager:</span>
                                <UserInfo name = {w.projectManager || ""} id = {w.projectManagerId || ""}/>
                            </div>
                            <div className = "pt-2 lineHeight15">
                                <span className = "fw-bold me-1">Project Creator:</span>
                                <UserInfo name = {w.projectCreator || ""} id = {w.projectCreatorId || ""}/>
                            </div>
                            <div className = "pt-2 lineHeight15">
                                <span className = "fw-bold me-1">Work Instruction Creator:</span>
                                <UserInfo name = {w.workCreator || ""} id = {w.workCreatorId || ""}/>
                            </div>
                            {w.workUpdaterId?
                            <div className = "pt-2 lineHeight15">
                                <span className = "fw-bold me-1">Work Instruction Updater:</span>
                                <UserInfo name = {w.workUpdater || ""} id = {w.workUpdaterId || ""}/>
                            </div>
                            :<></>}
                            <div className = "pt-2 lineHeight15">
                                <span className = "fw-bold me-1">Location:</span>
                                <a href = {`http://google.com/maps?q=${w.location}`} target = "_blank" rel = "noreferrer">
                                    {w.location}
                                </a>
                            </div>
                            <div className = "pt-2 lineHeight15"> 
                                <span className = "fw-bold me-1">
                                    Time:
                                </span>
                                {w.allDay === "yes"?
                                <>
                                    {w.startTime.substring(0, 10)}
                                    {w.startTime.substring(0, 10) === w.endTime.substring(0, 10)?
                                    null:` ~ ${w.endTime.substring(0, 10)}`}
                                </>
                                :
                                <>
                                    <>{w.startTime.substring(0, 10)}</> 
                                    <>
                                        {w.startTime.substring(10, 19)}
                                    </> 
                                    ~ 
                                    <>
                                        {w.startTime.substring(0, 10) === w.endTime.substring(0, 10)?
                                        null:w.endTime.substring(0, 10)}
                                    </>
                                    <>
                                        {w.endTime.substring(10, 19)}
                                    </>
                                </>
                                }
                            </div>
                            <div className = "pt-2 lineHeight15">
                                <span className = "fw-bold me-1">Technicians:</span>
                                {w.assignments.map((a, key: number) => <li key = {key} className = "m-2"><UserInfo id = {a.userId} name = {a.userName}/>{a.assignmentId?<Link className = "ms-2" to = {`/Assignments/${a.assignmentId}`}>Assignment</Link>:null}</li>)}
                            </div>
                        </CustomMarker>:null
                        )}
                    </LayerGroup>
                </LayersControl.Overlay>
                )}
            </LayersControl>
        </>
    )
}
